import PropTypes from "prop-types";

function BasicInput({ placeholder, label, type, name, onChange, error }) {
  return (
    <div className="basic-input flex flex-col mb-4">
      {label && <label className="label mb-2 text-gray-500">{label}</label>}
      <input
        onChange={onChange}
        className="input border rounded focus:outline-none focus:border-none"
        name={name}
        type={type}
        placeholder={placeholder}
      />
      {error && error.name === name && <small className="error">{error.message}</small>}
    </div>
  );
}

BasicInput.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.object,
};

export default BasicInput;
